import * as ActionTypes from './types.action';

export const setCleanMode = () => ({
  type: ActionTypes.SET_CLEAN_MODE_SUCCESS,
});
